export { barWidth, hours, index, percent } from '../finance/finance-format';

/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ C65 · the hours dashboard's number rules.                                 │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️⚠️ **THE SAME RULES AS THE MONEY TAB, BECAUSE THEY SIT SIDE BY SIDE.** A reader moves between
 * the two tabs comparing figures, and `−1:30` on one against `-1.5` on the other is the same fact
 * twice in two spellings. `H:MM`, the percentage, the index and the bar's clamp are all already
 * decided in `finance-format.ts` and are re-exported rather than re-derived.
 *
 * ⚠️ **The MINUS is U+2212, not a hyphen** — a hyphen in a column of `tabular-nums` sits at a
 * different height and width from the digits beside it.
 */

import { hours as plainHours } from '../finance/finance-format';

/**
 * `+3:30` / `−1:15` — a figure whose SIGN is the point: a rate gap, a carry-over, a variance.
 *
 * ⚠️ **A near-zero value gets no sign.** `+0:00` on a carry-over reads as a deliberate exact
 * landing; a bare `0:00` reads as nothing to report, which is what it is.
 */
export function signedHours(value: number | null): string {
  if (value === null || Number.isNaN(value)) return '–';
  const sign = value > 0.004 ? '+' : value < -0.004 ? '−' : '';
  return `${sign}${plainHours(Math.abs(value))}`;
}

/** `+3 munkanap` / `−2 nap` — a signed COUNT with its unit. ⚠️ Zero is `0`, not `+0`. */
export function signedCount(value: number | null, unit: string): string {
  if (value === null) return '–';
  const sign = value > 0 ? '+' : value < 0 ? '−' : '';
  return `${sign}${String(Math.abs(value))} ${unit}`;
}
